module.exports = __webpack_public_path__ + "static/media/youtube-f.37cc44c5.svg";